import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DataAccess } from './data-access';
import { urls } from '../models/constants';
import { CheckAppVersionRequest, CheckAppVersionResponse } from '../models/check-app-version-req-res';

@Injectable({
  providedIn: 'root'
})
export class CheckAppVersionService {
  private http: HttpClient = inject(HttpClient);
  constructor() { }

  async checkAppVersion(checkAppVersionRequest: CheckAppVersionRequest): Promise<CheckAppVersionResponse> {
    const headers = new HttpHeaders();
    const methodName = 'check-app-version';
    const timeOutVal = 15000;
    const DataAccessObj = new DataAccess(this.http, urls.apiUrl);
    return DataAccessObj.postData(methodName, checkAppVersionRequest, headers, timeOutVal)
    .then(res => res as CheckAppVersionResponse);
  }
}
